import tmhRequest from "@/config/tmhRequest";

export default {
  searchTalkRecording: function(data) {
    return tmhRequest({
      url: "/customer/tmh/talkrecording/searchtalkrecording",
      method: "post",
      data: data
    });
  },

  searchListTalkRecording: function(data) {
    return tmhRequest({
      url: "/customer/tmh/talkrecording/searchlisttalkrecording",
      method: "post",
      data: data
    });
  },

  addTalkRecording: function(data) {
    return tmhRequest({
      url: "/customer/tmh/talkrecording/addtalkrecording",
      method: "post",
      data: data
    });
  },

  editTalkRecording: function(data) {
    return tmhRequest({
      url: "/customer/tmh/talkrecording/edittalkrecording",
      method: "post",
      data: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/tmh/customer/talkrecording.js